import { render, staticRenderFns } from "./QSummitStepBackground.vue?vue&type=template&id=620e021d&"
import script from "./QSummitStepBackground.vue?vue&type=script&lang=js&"
export * from "./QSummitStepBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports